interface ITagManager {
  gtmId: string
  events?: TEvents
  auth?: string
  preview?: string
  dataLayerName?: string
  specifiedServerContainer?: string
}

interface IGetGTMScripts {
  gtmId: string
  events: TEvents
  auth: string
  preview: string
  dataLayerName: string
  specifiedServerContainer: string
}

type TDataLayer = { [key: string]: string | number }
type TEvents = { [key: string]: string | number }

const defaultDataLayerName = 'dataLayer'

function createTagManager() {
  function initialize({
    gtmId,
    events = {},
    dataLayerName = defaultDataLayerName,
    auth = '',
    preview = '',
    specifiedServerContainer = 'https://www.googletagmanager.com'
  }: ITagManager) {
    createDataLayer(dataLayerName)
    
    const gtmScripts = getGtmScripts({
      gtmId,
      events,
      dataLayerName,
      auth,
      preview,
      specifiedServerContainer,
    })
    document.head.insertBefore(gtmScripts.script(), document.head.childNodes[0])
    document.body.insertBefore(gtmScripts.noScript(), document.body.childNodes[0])
  }

  function send(dataLayer: TDataLayer, dataLayerName: string = defaultDataLayerName) {
    const dlName = dataLayerName as keyof typeof window
    if (window[dlName]) {
      window[dlName].push(dataLayer)
      return true
    } else {
      return false
    }
  }

  function getGtmScripts({ gtmId, events, dataLayerName, preview, auth, specifiedServerContainer }: IGetGTMScripts) {
    const gtm_auth = `&gtm_auth=${auth}`
    const gtm_preview = `&gtm_preview=${preview}`

    const noScript = () => {
      const noscript = document.createElement('noscript')
      noscript.innerHTML = `
        <iframe src="http://${specifiedServerContainer}/ns.html?id=${gtmId}${gtm_auth}${gtm_preview}&gtm_cookies_win=x"
          height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`
      return noscript
    }

    const script = () => {
      const script = document.createElement('script')
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', ${JSON.stringify(events).slice(1, -1)}});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;j.src='${specifiedServerContainer}/gtm.js?id='+i+dl+'${gtm_auth}${gtm_preview}&gtm_cookies_win=x';
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','${dataLayerName}','${gtmId}');`
      return script
    }

    return {
      noScript,
      script,
    }
  }

  function createDataLayer(dataLayerName: string) {
    // @ts-ignore
    window[dataLayerName] = window[dataLayerName] || []
  }

  return {
    initialize,
    send
  }
}

export const TagManager = createTagManager()
